function HomeLanding() {

  return (
    <div>
      <h1>Home Landing</h1>
    </div>
  );
}

export default HomeLanding;